import { GuestInboxSend } from '@new/domains/operations/components/StayTimeline/StayTimeline.types'

export const getSendAttemptKey = ({ template, kind, recipient }: GuestInboxSend) => {
  const audience = recipient?.isAdditionalGuest ? 'additional' : 'main'

  return [template, kind, recipient?.personId ?? '', audience].join('|')
}

interface GroupAttemptsParams<T> {
  items: T[]
  getKey: (item: T) => string | undefined
  isFailed: (item: T) => boolean
}

export const groupAttempts = <T>({ items, getKey, isFailed }: GroupAttemptsParams<T>) => {
  return items.reduce<T[][]>((groups, item) => {
    const current = groups.at(-1)
    const previous = current?.at(-1)
    const key = getKey(item)
    const isRetry =
      !!current && !!previous && key !== undefined && key === getKey(previous) && isFailed(previous)

    if (isRetry) {
      current.push(item)
    } else {
      groups.push([item])
    }

    return groups
  }, [])
}

interface GetAttemptsStatusParams {
  attempts: number
  status: string
  isFailed: boolean
}

export const getAttemptsStatus = ({ attempts, status, isFailed }: GetAttemptsStatusParams) => {
  if (attempts === 1) return status
  if (isFailed) return `Failed x${attempts}`

  return `${status} on try ${attempts}`
}
